/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Incident_DateInputs */

const en_cases_col_incident_date = /** @type {(inputs: Cases_Col_Incident_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident date`)
};

const pt_br2_cases_col_incident_date = /** @type {(inputs: Cases_Col_Incident_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data sinistro`)
};

/**
* | output |
* | --- |
* | "Incident date" |
*
* @param {Cases_Col_Incident_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_incident_date = /** @type {((inputs?: Cases_Col_Incident_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Incident_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_incident_date(inputs)
	return pt_br2_cases_col_incident_date(inputs)
});